import type { ObjectSchemaDefinition } from '@axinom/mosaic-ui';
import * as Yup from 'yup';

export const HostingServiceStorageConfigValidationSchema =
  Yup.object<ObjectSchemaDefinition>({
    provider: Yup.string().required('Provider is required'),
  });
